<template>
  <div class="flex flex-col items-center text-center p-6">
    <img :src="CancelBoostIcon" alt="Cancellation" class="w-[180px] h-[140px] mb-4" />
    <h3 class="text-[18px] font-semibold text-[#041A21] mb-6">Cancellation</h3>

    <button
      class="w-full text-left border border-grey-light-200 rounded-xl p-4 mb-3 hover:border-brand-300 hover:bg-[#E7F1F4] transition-colors"
      @click="$emit('cash-refund')"
    >
      <div class="flex justify-between items-center">
        <div>
          <p class="text-[14px] font-semibold text-[#36484D]">Cash Refund</p>
          <p class="text-[14px] text-grey-light-600 mt-1">
            Receive your refund as a cash deposit into your selected bank account. A cancellation fee will be applied
            and deducted from the refunded amount.
          </p>
        </div>
        <ChevronRight class="h-5 w-5 text-grey-light-400 shrink-0 ml-3" />
      </div>
    </button>

    <button
      class="w-full text-left border border-grey-light-200 rounded-xl p-4 hover:border-brand-300 hover:bg-[#E7F1F4] transition-colors"
      @click="handleRedeemVoucher"
    >
      <div class="flex justify-between items-center">
        <div>
          <p class="text-[14px] font-semibold text-[#36484D]">Redeem Voucher</p>
          <p class="text-[14px] text-grey-light-600 mt-1">
            Redeem your full refund as a voucher with no cancellation fee. The voucher can be used to purchase goods at
            "{{ merchantName }}" only.
          </p>
        </div>
        <ChevronRight class="h-5 w-5 text-grey-light-400 shrink-0 ml-3" />
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
import CancelBoostIcon from '@/assets/shopper/rewards/piggy-bank-broken.svg';
import { ChevronRight } from 'lucide-vue-next';

defineProps<{ merchantName: string; isThresholdMet: boolean }>();
const emit = defineEmits<{ 'cash-refund': []; 'redeem-voucher': [] }>();

const handleRedeemVoucher = () => {
  emit('redeem-voucher');
};
</script>
